
/* eslint-disable default-case */
import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { TabContent, TabPane, Nav, NavItem, NavLink, } from 'reactstrap';
import { useResizeDetector } from 'react-resize-detector/build/withPolyfill';
import {
    ButtonGroup,
    Button,
    Spinner,
} from 'reactstrap'

import PdfPreview from 'components/Shared/PdfPreview';
import { PDFSignaturesContainer } from 'components/Editor/Canvas/PdfFormat';
import { useSign, CHANGE_PREVIEW, SET_SIGNATURE_CONFIRMATIONS, SET_PDF_META } from 'context/signview';

const contentStyle = { width: '100%', height: '100%', border: 'none' };

const getRatio = (val, measure, unit = '') => val * measure + unit;

// function Markup({ width, height }) {
//     const saveComment = (e) => {
//         console.log(e.target.value)
//         e.preventDefault();
//         e.stopPropagation();
//     }
//     return (
//         <div style={{
//             left: width,
//             top: height,
//             // left: getRatio(0, 0, "px"),
//             // top: getRatio(0, 0, "px"),
//             // width: getRatio(width, width, "px"),
//             // height: getRatio(width, height, "px"),
//             position: 'absolute'
//         }}>
//             {/* <SignaturesContainer /> */}
//             <i className="fas fa-comment text-primary"></i>
//             <textarea onBlur={saveComment} className="form-control " type="text" style={{ width: "200px" }} onClick={(e) => { e.stopPropagation() }}></textarea>
//         </div>
//     )
// }

export function PDFPreview({ contract, participant, importedPdf, signatureConfirmations, onConfirmSignature }) {
    const { t } = useTranslation()
    const [{pdfMeta}, dispatch] = useSign()
    const [totalPages, setTotalPages] = useState()
    const [currentPage, setCurrentPage] = useState(1);
    const [height, setHeight] = useState()
    const [width, setWidth] = useState()
    const [originalWidth, setOriginalWidth] = useState()
    const [ratio, setRatio] = useState(1)
    const canvasRef = useRef();

    const onResize = useCallback(
        (width, height) => {
            setWidth(width)
            setRatio(width/originalWidth)
        },
        [originalWidth],
    )
    const { width: resizeWidth, height: resizeHeight, ref } = useResizeDetector({
        onResize
    });
    const handlePageLoad = ({ width, height, originalWidth, ratio, ...page }) => {
        setOriginalWidth(originalWidth);
        setHeight(height)
        setRatio(ratio || 1);
    }


    const handleDocumentLoad = ({ numPages, rest }) => {
        setTotalPages(numPages)
        dispatch({type: SET_PDF_META, pdfMeta: { totalPages: numPages }})
    }
    const [comment, setComment] = useState([]);

    const onMouseUp = (prop) => {
        setComment([...comment, prop])
    }
    const handlePageChange = (page) => {
        setWidth(0)
        setHeight(0)
        dispatch({type: SET_PDF_META, pdfMeta: { currentPage: page }})
    }
    console.log({width})
    const styles = { targetDiv: { height: `calc(100vh - ${width < 500 ? 330 : 265}px)` } }

    const handleConfirmSignature = (participant, signature) => {

    }
    
    useEffect(() => {
        setWidth(resizeWidth)
    }, [pdfMeta.currentPage])

    return (
        <>
        <div ref={ref} className="overflow-x-hidden bg-white" style={styles.targetDiv}>
            <div className="h-100">
                {/* <DndProvider backend={HTML5Backend}> */}
                <PdfPreview
                    onMouseUp={onMouseUp}
                    // controls
                    // controlsClassName="d-none d-sm-none d-md-block"
                    width={width}
                    url={importedPdf}
                    pageNumber={pdfMeta.currentPage}
                    onDocumentLoad={handleDocumentLoad}
                    onPageLoad={handlePageLoad}
                    onPageChange={handlePageChange}
                    canvasRef={canvasRef}
                >
                    {/* {comment.map((m) => (
                        <Markup
                            width={m.clientX}
                            height={m.clientY}
                        />
                    ))} */}
                    {
                        ['SENT_TO_SIGN'].includes(contract.status) &&
                        <PDFSignaturesContainer
                            document={contract}
                            isEditable={false}
                            width={width}
                            height={height}
                            currentPage={pdfMeta.currentPage}
                            participantId={participant?._id}
                            ratio={ratio}
                            signatureConfirmations={signatureConfirmations}
                            showSignatureConfirmations={contract.signCheckConfirmation && participant.status === 'RECEIVED_TO_SIGN'}
                            onConfirmSignature={onConfirmSignature}
                        />
                    }
                </PdfPreview>

                {/* </DndProvider> */}
            </div>
        </div>
        </>
    )
}


export default function PDFPreviewOld() {

    const [tab, setTab] = useState('importedPdf')
    const [{ contract, previewUrl, signatureConfirmations }, dispatch] = useSign();
    const { t } = useTranslation();

    useEffect(() => {
        dispatch({ type: CHANGE_PREVIEW, previewUrl: contract[tab], isNom: tab === 'nom151', isRfc3161: tab === 'rfc3161' })
    }, [contract, dispatch, previewUrl, tab]);

    const handleChangeTab = (tabName) => {
        setTab(tabName);
        dispatch({ type: CHANGE_PREVIEW, previewUrl: contract[tabName], isNom: tabName === 'nom151', isRfc3161: tab === 'rfc3161' })
    }

    const handleConfirmSignature = useCallback((participant, signature) => {
        dispatch({ type: SET_SIGNATURE_CONFIRMATIONS, signatureConfirmation: signature._id })
    }, [dispatch]);

    return (
        <>
            <Nav tabs className="bg-white">

                <NavItem >
                    <NavLink active={tab === 'importedPdf'} onClick={() => handleChangeTab('importedPdf')}>{t('sign.contract.tab_contract')}</NavLink>
                </NavItem>

                <NavItem hidden={!contract.nom151}>
                    <NavLink active={tab === 'nom151'} onClick={() => handleChangeTab('nom151')}>{t('sign.contract.tab_certificate')}</NavLink>
                </NavItem>

                <NavItem hidden={!contract.rfc3161}>
                    <NavLink active={tab === 'rfc3161'} onClick={() => handleChangeTab('rfc3161')}>{t('sign.contract.tab_rfc3161', { context: contract.jurisdiction })}</NavLink>
                </NavItem>

                <NavItem hidden={!contract.nom151Bin}>
                    <NavLink><a href={contract.nom151Bin}>{t('sign.contract.tab_downloadcert')}</a></NavLink>
                </NavItem>

                <NavItem hidden={!contract.rfc3161Bin}>
                    <NavLink><a href={contract.rfc3161Bin}>{t('sign.contract.tab_downloadrfc3161', { context: contract.jurisdiction })}</a></NavLink>
                </NavItem>

                <NavItem hidden={!contract.EIP72Report}>
                    <NavLink><a href={contract.EIP72Report}>{t('sign.contract.tab_downloadeip72')}</a></NavLink>
                </NavItem>

            </Nav>
            <TabContent activeTab={tab} className="">
                <TabPane tabId={tab} className="h-100" id="document-container">
                    <PDFPreview
                        contract={contract}
                        participant={contract.signViewOptions?.currentParticipant}
                        importedPdf={previewUrl}
                        signatureConfirmations={signatureConfirmations}
                        onConfirmSignature={handleConfirmSignature}
                    />
                </TabPane>
            </TabContent>
        </>
    )
}


